<template>
  <div>
    <c-card
      :title="
        '\'' + popupParam.requestContents + '\'에 대한 즉시조치 엑셀업로드'
      "
      class="cardClassDetailForm"
    >
      <template slot="card-button">
        <q-btn-group outline>
          <c-btn
            v-if="editable"
            label="LBLAPPLY"
            icon="save"
            @btnClicked="acceptData"
          />
        </q-btn-group>
      </template>
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :disabled="true"
            codeGroupCd="IBM_TASK_TYPE_CD"
            type="edit"
            itemText="codeName"
            itemValue="code"
            name="ibmTaskTypeCd"
            label="LBLWORK"
            v-model="popupParam.ibmTaskTypeCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
          <c-text
            :editable="editable"
            :disabled="true"
            label="요청부서/이름/요청일"
            name="request"
            v-model="request"
          >
          </c-text>
        </div>
      </template>
    </c-card>
    <c-excel-upload :editable="editable" :excelUploadInfo="excelUploadInfo" />
  </div>
</template>

<script>
export default {
  name: "impr-immediate-excel-upload",
  props: {
    popupParam: {
      type: Object,
      default: function () {
        return {
          requestContents: "",
          ibmTaskTypeCd: "",
        };
      },
    },
  },
  data() {
    return {
      excelUploadInfo: {
        rowKeys: ["sopImprovementId"], // 데이터들의 키 속성값
        taskClassCd: "IBM_IMMEDIATELY", // 엑셀업로드 양식 구분 값
        sheetNum: 0,
        columns: [
          [
            {
              name: "plantCd",
              label: "LBLPLANT",
              type: "plant",
              required: true,
              style: "width:100px",
              align: "center",
            },
            {
              name: "actionDeptName",
              label: "조치부서",
              type: "dept",
              deptCd: "actionDeptCd",
              required: true,
              style: "width:120px",
              align: "center",
            },
            {
              name: "ibmTitle",
              label: "LBLTITLE",
              required: true,
              style: "width:300px",
              align: "left",
            },
            {
              name: "actionContents",
              label: "조치내용",
              required: true,
              style: "width:400px",
              align: "left",
            },
            {
              name: "actionCompleteDate",
              label: "조치완료일",
              type: "date",
              required: true,
              style: "width:120px",
              align: "center",
            },
            // {
            //   name: 'actionUserName',
            //   label: '조치자',
            //   type: 'user',
            //   userId: 'actionUserId',
            //   required: true,
            //   style: 'width:120px',
            // },
          ],
        ],
        data: [],
      },
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
    request() {
      return (
        this.$store.getters.user.deptName +
        " / " +
        this.$store.getters.user.userName +
        " / " +
        this.$comm.getToday()
      );
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      // code
      // list setting
    },
    acceptData() {
      if (this.excelUploadInfo.data) {
        let dataCntCheck = true;
        let errorDataCheck = false;
        if (
          !this.excelUploadInfo.data[0] ||
          this.excelUploadInfo.data[0].length === 0
        ) {
          dataCntCheck = false;
        }
        if (
          this.$_.findIndex(this.excelUploadInfo.data[0], (item) => {
            return item.error_message;
          }) > -1
        ) {
          errorDataCheck = true;
        }
        if (!dataCntCheck) {
          window.getApp.$emit("ALERT", {
            title: "LBLGUIDE", // 안내
            message:
              "업로드할 데이터가 없는 Sheet가 있습니다.\n데이터 확인 또는 엑셀을 업로드 하였는지 확인바랍니다.",
            type: "warning", // success / info / warning / error
          });
        } else {
          if (errorDataCheck) {
            window.getApp.$emit("CONFIRM", {
              title: "LBLCONFIRM",
              message:
                "에러가 있는 데이터가 존재합니다.\n에러 있는 데이터를 제외한 나머지 데이터를 적용하시겠습니까?",
              type: "info", // success / info / warning / error
              confirmCallback: () => {
                this.$emit("closePopup", this.excelUploadInfo.data[0]);
              },
              cancelCallback: () => {},
            });
          } else {
            this.$emit("closePopup", this.excelUploadInfo.data[0]);
          }
        }
      }
    },
  },
};
</script>
